import $console from '@zuto/utilities/src/$console'
import { Option } from '@zuto/atoms'
import ZutoAnalyticsHelper from '@zuto-internal/zuto-analytics-helper'
import { AddressDetails } from '../components/Questions/CardlessAddressHistoryQuestion/AddressHistoryContext'
import PostcodeRepository from '../repository/postcode-repository'
import { mapAddresses, mapAddress } from '../Mappers/AddressMapper'
import { fireReactGAEvent } from '../components/Questions/utils'

type possibleExperiments = 'AddressDetailsV1' | 'AddressRedesignV2'
interface PostcodeServiceResult {
  getAddresses: (addressQuery: string) => Promise<Option[]>
  retrieveAddress: (addressId: string, experimentName: possibleExperiments) => Promise<AddressDetails>
}

const PostcodeService = (config: Record<string, string>): PostcodeServiceResult => {
  const zutoAnalyticsHelper = new ZutoAnalyticsHelper()
  const postcodeRepository = PostcodeRepository(config)
  const getAddresses = (addressQuery: string) => new Promise<Option[]>((resolve, reject) => {
    fireReactGAEvent({
      category: 'Application Form',
      action: 'Postcode Lookup',
      label: 'Search'
    })
    postcodeRepository
      .findByText(addressQuery)
      .then((matches) => {
        if (Object.keys(matches).length === 0) {
          fireReactGAEvent({
            category: 'Application Form',
            action: 'Postcode Lookup',
            label: 'No Addresses Found',
            nonInteraction: true
          })
          reject(new Error('No addresses match that postcode'))
        } else if (matches.Items[0].Type === 'Postcode') {
          postcodeRepository.findByContainer(matches.Items[0].Id).then((addresses) => {
            if (addresses && addresses.length > 0) {
              const mappedAddress = mapAddresses(addresses)
              resolve(mappedAddress)
            } else {
              fireReactGAEvent({
                category: 'Application Form',
                action: 'Postcode Lookup',
                label: 'No Addresses Found',
                nonInteraction: true
              })
              reject(new Error('No addresses in this container'))
            }
          })
        } else {
          const mappedMatches = mapAddresses(matches.Items)
          resolve(mappedMatches)
        }
      })
      .catch((error) => {
        $console.error(error)
        reject(error)
      })
  })

  const retrieveAddress = (addressId: string, experimentName: possibleExperiments) => new Promise<AddressDetails>((resolve, reject) => {
    postcodeRepository.retrieveAddress(addressId).then((match) => {
      if (match && !match.Error) {
        const mappedAddress = mapAddress(match)
        resolve(mappedAddress)
      } else {
        // this.analyticsService.pushPostcodeAnywhereNoResults("", postcode, "retrieve");
        reject(match.Error)
      }
    })
      .catch((error) => {
        $console.error(error)
        reject(error)
        try {
          zutoAnalyticsHelper.sendCustomEvent({
            eventType: 'loqateRetrieve - Failed',
            eventCategory: 'Loqate',
            experiment: experimentName
          })
        } catch (e) {
          $console.error('zutoAnalyticsHelper.sendCustomEvent error', e)
        }
      })
  })

  return {
    getAddresses,
    retrieveAddress
  }
}

export default PostcodeService
